import React from 'react';
import { TaraCard, TaraCardContent } from '../ui/TaraCard';

const FootprintBar = ({ past, present, future }) => {
  return (
    <TaraCard className="bg-stone-50 border-stone-200">
      <TaraCardContent className="p-4">
        <div className="flex items-center justify-between gap-4">
          {/* Past */}
          <div className="flex-1 text-center">
            <div className="text-xs text-stone-500 mb-1">Past</div>
            <div className="text-xs font-medium text-stone-700">{past}</div>
          </div>

          {/* Arrow */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-0.5 bg-stone-300" />
            <div className="w-2 h-2 rounded-full bg-cosmic-500" />
            <div className="w-8 h-0.5 bg-stone-300" />
          </div>

          {/* Present */}
          <div className="flex-1 text-center">
            <div className="text-xs text-stone-500 mb-1">Present</div>
            <div className="text-xs font-medium text-stone-900">{present}</div>
          </div>

          {/* Arrow */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-0.5 bg-stone-300" />
            <div className="w-2 h-2 rounded-full bg-stone-300" />
          </div>

          {/* Future */}
          <div className="flex-1 text-center">
            <div className="text-xs text-stone-500 mb-1">Future</div>
            <div className="text-xs font-medium text-stone-700">{future}</div>
          </div>
        </div>
      </TaraCardContent>
    </TaraCard>
  );
};

export default FootprintBar;